import {createRoot} from 'react-dom/client';
import $ from 'jquery';
import './custom.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initRemoteLogger } from './utils/remoteLogger';

// Globalny, nieblokujący logger błędów (Firebase) + hook na wszystkie $.ajax.
initRemoteLogger($);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
